import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useParams } from "react-router-dom";
import { unwrapResult } from '@reduxjs/toolkit'
import { fetchUnitOfMeasures } from "../../../store/thunks/unitOfMeasuresThunk";
import { fetchIngredient, saveIngredient } from "../../../store/thunks/ingredientsThunk";
import { getUnitOfMeasures, unloadUnitOfMeasures } from "../../../store/slices/datasources/unitOfMeasuresSliceDatasource";
import { getIngredient, unloadIngredients } from "../../../store/slices/datasources/ingredientsSliceDatasource";
import WithLoadingPage from "../commons/withLoadingPage";
import Flash from "../elements/flash";
import PageSubHeader from "../elements/pageSubHeader";

const IngredientForm = props => {
    
	const dispatch = useDispatch();
    const history = useHistory();
	const routeParams = useParams();
    const { id: ingredientId } = routeParams;
    const unitOfMeasures = useSelector(getUnitOfMeasures);
	const ingredient = useSelector(getIngredient(ingredientId));
	const { setLoading } = props;
	const [request, setRequest] = React.useState({ id: null, unit_of_measure_id: 0, code: "", name: "", description: "" });
	const [error, setError] = React.useState({ unit_of_measure_id: null, code: null, name: null });

    React.useEffect(() => {
        return () => {
            dispatch(unloadUnitOfMeasures());
            dispatch(unloadIngredients());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {		
        async function initialize() {
            setLoading(true);
            await dispatch(fetchUnitOfMeasures());
            if (parseInt(ingredientId)) {
                await dispatch(fetchIngredient(getQueryFilter()));
            }
            setLoading(false);
        }
		
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, ingredientId]); 
	
	React.useEffect(() => {
		if (ingredient) {
			const mapViewToModel = {
				id: ingredient.id,
				unit_of_measure_id: ingredient.unit_of_measure_id,
				code: ingredient.code,
				name: ingredient.name,
				description: ingredient.description
			}

			setRequest(prev => { 
                return { 
                    ...prev, 
                    ...mapViewToModel 
                }
            });
		}
	}, [ingredient]);

    const getQueryFilter = () => {
        const queryFilter = {
            id: ingredientId
        };

        return {
            query: queryFilter
        };
    }
    
	const handleInputChange = element => {
		const { name, value } = element.target;
		setRequest({...request, [name]: value});
	}

	const handleFormSubmit = async event => {
		event.preventDefault();
		setLoading(true);
		await dispatch(saveIngredient(request))
			.then(unwrapResult)
			.then(() => {
				setLoading(false);
				setError({ ...error, code: null, name: null });
				history.push('/data/ingredients');
			})
			.catch(exception => {
				setLoading(false);
				setError(exception.errors);
			});
	}

    return (
        <React.Fragment>
            <PageSubHeader title={`${ingredientId === "add" ? "New" : "Edit"} Ingredient`} />
            <div className="mx-auto w-2/4">
                <Flash />
                <div className="classic card">
                    <div className="card-header bg-light-600">
                        <h3 className="card-title">Ingredient Form</h3>
                    </div>
                    <div className="card-body text-left">
                        <form className="w-full" onSubmit={handleFormSubmit}>
                            <div className="form-group">
                                <label className="form-label" htmlFor="unit_of_measure_id">Unit of Measure</label>
                                <select id="unit_of_measure_id" name="unit_of_measure_id" className="form-control" value={request.unit_of_measure_id} onChange={handleInputChange}>
                                    <option value="">- Select -</option>
                                    {unitOfMeasures.map(unitOfMeasure => <option key={unitOfMeasure.id} value={unitOfMeasure.id}>{unitOfMeasure.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <div className="flex">
                                    <div className="w-1/2 mr-20">
                                        <label className="form-label" htmlFor="code">Code</label>
                                        <input id="code" name="code" type="text" className="form-control" value={request.code} onChange={handleInputChange} />
                                    </div>
                                    <div className="w-1/2 ml-2">
                                        <label className="form-label" htmlFor="name">Name</label>
                                        <input id="name" name="name" type="text" className="form-control" value={request.name} onChange={handleInputChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-group">
                                <label className="form-label" htmlFor="description">Description</label>
                                <textarea id="description" name="description" type="text" className="form-control" value={request.description} onChange={handleInputChange} rows="5" resize="none" />
                            </div>
                            <div className="form-group text-right">
                                <NavLink to="/data/ingredients" className="btn btn-secondary mr-4">
                                    <i className="las la-undo" />
                                    Back
                                </NavLink>
                                <button className="btn btn-primary mr-4">
                                    <i className="las la-save" />
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
 
export default WithLoadingPage(IngredientForm);